import { createAction } from 'redux-actions';
import { UserOutput } from 'src/common/types/user';

export const ME_ACTIONS_TYPES = {
  nav: {
    userMenu: {
      darkModeChanged: '[Nav UserMenu] Darkmode changed',
    },
  },
  profile: {
    darkModeChanged: '[Profile] Darkmode changed',
  },
  playerAppearance: {
    colorChanged: '[Player Appearance] Color changed',
    clearWatermark: '[Player Appearance] Clear watermark',
    watermarkLinkChanged: '[Player Appearance] Watermark link changed',
    removeBrandingChanged: '[Player Appearance] Remove branding changed',
  },
} as const;

export const meActions = {
  nav: {
    userMenu: {
      darkModeChanged: createAction<{ dark_mode: boolean }>(
        ME_ACTIONS_TYPES.nav.userMenu.darkModeChanged
      ),
    },
  },
  profile: {
    darkModeChanged: createAction(ME_ACTIONS_TYPES.profile.darkModeChanged),
  },
  playerAppearance: {
    colorChanged: createAction<{ color: string }>(
      ME_ACTIONS_TYPES.playerAppearance.colorChanged
    ),
    clearWatermark: createAction(
      ME_ACTIONS_TYPES.playerAppearance.clearWatermark
    ),
    watermarkLinkChanged: createAction<{ watermark_link: string }>(
      ME_ACTIONS_TYPES.playerAppearance.watermarkLinkChanged
    ),
    removeBrandingChanged: createAction<{ remove_branding: boolean }>(
      ME_ACTIONS_TYPES.playerAppearance.removeBrandingChanged
    ),
  },
  editUser: createAction<Partial<UserOutput>>('EDIT_USER'),
};
